import React from "react";
import { PureAppComponent } from "../../../Components/AppComponent";
import {
  Form,
  Button,
  InputGroup,
  FormControl,
  
} from "react-bootstrap";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import api from "../../../Services/Api/api";
import CustomerReceipt from "./CustomerReceipt";

const SCREEN_NAME = "ACCOUNT_PRINT_CUSTOER_RECEIPT_SCREEN";

class PrintCustomerReceiptInner extends PureAppComponent {
  constructor(props) {
    super(props);

    const refDate = new Date().setMonth(new Date().getMonth() - 1);
    this.state = {
      loading: false,
      error: null,
      data: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date(refDate).getMonth(),
      year: new Date(refDate).getFullYear(),
      index: this.props.index,
      account: this.props.account,
    };

    this.months =
      "January, February, March, April, May, June, July, August, September, October, November, December"
        .split(",")
        .map((x) => x.trim());

    this.componentRef = React.createRef(null);
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });

      const res = await api.get("v1/transaction/customerReceipt", {
        account: this.state.account._id,
        range0,
        range1,
      });
      this.setAsyncState({ data: res, loading: false });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  nextAccount(n) {
    const {
      props: { accounts },
      state: { index },
    } = this;
    let nextIndex = index + n;

    nextIndex = Math.min(accounts.length - 1, nextIndex);
    nextIndex = Math.max(0, nextIndex);

    this.setAsyncState({
      index: nextIndex,
      account: accounts[nextIndex],
    }).then(() => this.onSubmit());

    if (accounts.length - nextIndex < 4) {
      this.props.loadMore?.();
    }
  }

  reactToPrintTrigger = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="secondary">
          Print
        </Button>
      </div>
    );
  };

  renderInner() {
    const {
      state: {
        loading,
        error,
        month,
        year,
        period,
        range0,
        range1,
        data,
        index,
        account,
      },
      props: { multipleAccounts = false, accounts },
    } = this;

    return (
      <div className="customer-receipt">
        {error ? <div className="errormsg">{error}</div> : null}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
        >
          <div role="group" className="mb-3 btn-group">
            <label
              className={
                period === "monthly"
                  ? "btn btn-success"
                  : "btn btn-outline-success"
              }
            >
              Monthly
              <input
                className="btn-check"
                name="radio"
                type="radio"
                autoComplete="off"
                value="monthly"
                checked={period === "monthly"}
                onChange={() => this.setState({ period: "monthly" })}
              />
            </label>

            <label
              className={
                period === "custom"
                  ? "btn btn-success"
                  : "btn btn-outline-success"
              }
            >
              Custom
              <input
                className="btn-check"
                name="radio"
                type="radio"
                autoComplete="off"
                value="custom"
                checked={period === "custom"}
                onChange={() => this.setState({ period: "custom" })}
              />
            </label>
          </div>

          {loading ? <span className="m-3">Loading...</span> : null}

          {period === "monthly" ? (
            <InputGroup className="mb-3">
              <FormControl
                value={month || ""}
                onChange={(e) => this.setState({ month: e.target.value })}
                as="select"
                required
              >
                <option value="">Select Month</option>
                {this.months.map((x, i) => (
                  <option key={i} value={i}>
                    {x}
                  </option>
                ))}
              </FormControl>
              <FormControl
                type="number"
                value={year || ""}
                onChange={(e) => this.setState({ year: e.target.value })}
                placeholder="Year"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          ) : (
            <InputGroup className="mb-3">
              <FormControl
                type="date"
                value={range0 || ""}
                onChange={(e) => this.setState({ range0: e.target.value })}
                placeholder="From Date"
                required
              />

              <FormControl
                type="date"
                value={range1 || ""}
                onChange={(e) => this.setState({ range1: e.target.value })}
                placeholder="To Date"
                required
              />

              <Button disabled={loading} type="submit">
                Generate
              </Button>
            </InputGroup>
          )}
        </Form>

        {multipleAccounts ? (
          <div
            style={{
              marginBottom: "-26px",
              textAlign: "right",
              marginRight: "50px",
            }}
          >
            <span>
              {index + 1}/{accounts?.length}
            </span>{" "}
            <Button
              size="sm"
              onClick={() => this.nextAccount(-1)}
              disabled={index <= 0}
            >
              Prev
            </Button>{" "}
            <Button size="sm" onClick={() => this.nextAccount(1)}>
              Next
            </Button>
          </div>
        ) : null}

        {data ? (
          <>
            <ReactToPrint
              content={() => this.componentRef.current}
              documentTitle={`recovery-receipt-${account?.shortId}`}
              // onAfterPrint={this.handleAfterPrint}
              // onBeforeGetContent={this.handleOnBeforeGetContent}
              // onBeforePrint={this.handleBeforePrint}
              removeAfterPrint
              trigger={this.reactToPrintTrigger}
            />

            <div
              style={{
                border: "1px solid lightgray",
                boxShadow: "lightgrey 3px 3px 9px",
              }}
            >
              <CustomerReceipt
                ref={this.componentRef}
                data={data}
                key={account?._id}
              />
            </div>
          </>
        ) : null}
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Customer Receipt`,
          // showFooter: false,
          showSubmitBtn: false,
          modalProps: {
            size: "md",
            scrollable: true,
            backdrop: true,
          },
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const PrintCustomerReceipt = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintCustomerReceiptInner);

export default PrintCustomerReceipt;
